import React, { FC, PropsWithChildren, useEffect } from 'react';

import { Error, Flex, HSLoader } from '../components';
import { useGetHotelDocumentFromFirestore, useQueryHelper } from '../queries';
import { useHotelState, useOrganizationState } from '../state';

export const HotelContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const { organizationData } = useOrganizationState();
  const { setHotelData } = useHotelState();
  const hotelDocument = useGetHotelDocumentFromFirestore(organizationData.hotel || '');
  const { data: hotelData } = hotelDocument;
  const { isLoading, isError } = useQueryHelper({ queries: [hotelDocument] });

  useEffect(() => {
    if (hotelData) {
      setHotelData(hotelData);
    }
  }, [hotelData]);

  if (isLoading) {
    return (
      <Flex fullHeight itemAlign="center" justifyContent="center"><HSLoader size={80} /></Flex>
    );
  }

  if (isError) {
    return <Error errorMessage="Error loading hotel data, please try again...." />;
  }

  return (
  // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{ children }</>
  );
};
